"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiProvider = void 0;
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file -- wrapper */

const API_TIMEOUT = 10000;
const swrConfig = {
  focusThrottleInterval: 300000,
  suspense: false,
  ..._checkoutUtils.basicSwrOptions
};
const ApiProvider = ({
  children
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    globalApiUrl,
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi', 'staticApi']);
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    formattedToken: token
  } = (0, _auth.useToken)();
  const globalClientProps = (0, _react.useMemo)(() => ({
    baseUrl: globalApiUrl,
    language,
    tenant,
    timeout: API_TIMEOUT,
    token
  }), [globalApiUrl, language, tenant, token]);
  const staticClientProps = (0, _react.useMemo)(() => ({
    baseUrl: staticApiUrl,
    language,
    tenant,
    timeout: API_TIMEOUT
  }), [language, staticApiUrl, tenant]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_fetching.SWRConfig, {
    value: swrConfig,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
      ...globalClientProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_staticApiClientReact.ApiClientProvider, {
        ...staticClientProps,
        children: children
      })
    })
  });
};
exports.ApiProvider = ApiProvider;
